import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { registerSchema } from './engine/registry';
import { boardAiLiteracySchema } from './schemas/board-ai-literacy';
import './styles.css';

registerSchema(boardAiLiteracySchema);

// The SPA mounts into a Hugo-rendered <div id="assessment-root"> inside
// layouts/assessments/list.html and layouts/assessments/single.html. If the
// bundle ever loads on a page without that mount point, exit silently — the
// page is responsible for its own content in that case.
const rootEl = document.getElementById('assessment-root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <BrowserRouter basename="/assessments">
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
